import authAxios from "../authAxios";

export const getDuckApplications = () => {
  return authAxios.get("/v1/duck/applications");
};

export const updateDuckApplication = (data) => {
  return authAxios.put("/v1/duck/applications", data);
};
